import {React, useContext} from 'react'
import { formatNumbers } from '../Functions/formatNumbers'
import calculateTax from '../Functions/calculateTax'
import Button from '../Atoms/Button'
import PrevNext from '../Atoms/PrevNext'
import './Products.sass'
import Eco from '../../Images/icon-eco.svg'
import { calculateNetto100 } from '../Functions/getMarge'
import { roundTo } from '../Functions/formatNumbers'

import { ProductContext } from '../Context/Context'

const ChooseProducts = (props) => {

	const {
		products,
		bestellung,
		setBestellung,
		step,
		setStep } = useContext(ProductContext)


	const selectProduct = (p) => {

		const product = p
		const nettoTotal = roundTo(props.bestellung.totals.totalAmount / 100 * calculateNetto100(props, product), 2)

		// console.log(props.bestellung, product, nettoTotal)
		
		setBestellung(prev => ({
			...prev,
			totals: {
				...props.bestellung.totals,
				productName: product.title.rendered,
				productId: product.id,
				aktion: product.acf.rabatt_aktion ? product.acf.rabatt_aktion : false,
				productExtra: product.acf.aufpreis === '' ? 0 : parseFloat(product.acf.aufpreis),
				totalNetto: nettoTotal,
				totalBrutto: parseFloat(calculateTax(nettoTotal)),
				per100Netto: calculateNetto100(props, product)
			}
		}))
		return props.next()
	}
// return( <p>test</p>	 )

	return (
		<div className="no__products-container">
			<div className="no_products">
				{products.map(product => (
					<div className={`product ${product.id === bestellung.totals.productId ? 'active' : ''}`} key={product.id}>
						{ product.acf.nl_kennzeichnung.length > 0 && 
							product.acf.nl_kennzeichnung.map((decoration, index) => {
								if (decoration === 'eco') {
									return <div className="eco-flag" key={index}><img src={Eco} alt="ECO" /><div className="wrap__element"></div></div>
								} else {
									return <div className="aktions-flag" key={index}><p>Aktion</p><div className="wrap__element"></div></div>
								}
							 })
						}
						<h3>{product.title.rendered}</h3>
						<div className="price__banner">
							<p>pro 100l inkl. MwSt.</p>
							<strong>{
								formatNumbers(
									(
									calculateNetto100(props, product)
									)
									* 1.19
								)
							} €</strong>
						</div>
						<div className="no__angebotstext" dangerouslySetInnerHTML={{__html: product.content.rendered}}></div>
						<p className="product__gesamt">Gesamtpreis: <span>{
							formatNumbers(calculateNetto100(props, product) * 1.19 * bestellung.totals.totalAmount / 100)
							
						} €*</span></p>
						<Button className="no__primary" click={() => selectProduct(product, product.id)} title="Auswählen"/>
					</div>
				))}
			</div>
		
			<p className="info">
			* Sie erhalten immer unser günstigstes Angebot, sofern alle Leistungsbestandteile inhaltlich und zeitlich mit diesem Angebot identisch sind. Alle Brutto-Preise inkl. der gesetzlichen MwSt. von 16%. Ab dem 01.01.2021 gilt: Alle Preise inkl. CO2-Abgabe. Alle Brutto-Preise inkl. der gesetztlichen MwSt von 19%.
			</p>
			<PrevNext
					setStep={setStep}
					step={step}
					disabled={bestellung.totals.productName === ""}
				/>
		</div>
	)
}

export default ChooseProducts
